import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper
 */
const Wrapper = ({
                   anchorPoint,
                   anchorName,
                   containerId,
                   containerClass,
                   children,
                 }) => {
  //
  const getAnchor = (anchorChildren) => {
    if (anchorPoint !== null && anchorName !== null) {
      return (<div id={anchorPoint} data-id={anchorPoint} data-anchor-name={anchorName}>
        {(anchorChildren !== null) ? anchorChildren: null}
      </div>);
    } else if (anchorPoint !== null) {
      return (
        <div id={anchorPoint}>
          {(anchorChildren !== null) ? anchorChildren: null}
        </div>
      );
    } else if (anchorName !== null) {
      return (
        <div data-anchor-name={anchorName}>
          {(anchorChildren !== null) ? anchorChildren: null}
        </div>
      );
    } else {
      return (
        (anchorChildren !== null) ? anchorChildren: null
      );
    }
  };
  //
  const getContainer = (containerChildren) => {
    if (containerId !== null && containerClass !== null) {
      return (
        <div id={containerId} className={containerClass}>
          {(containerChildren !== null) ? containerChildren: null}
        </div>
      )
    } else if (containerId !== null) {
      return (
        <div id={containerId}>
          {(containerChildren !== null) ? containerChildren: null}
        </div>
      )
    } else if (containerClass !== null) {
      return (
        <div className={containerClass}>
          {(containerChildren !== null) ? containerChildren: null}
        </div>
      )
    } else {
      return (
        <div>
          {(containerChildren !== null) ? containerChildren: null}
        </div>
      )
    }
  };
  //
  return getAnchor(getContainer(children));
};
Wrapper.propTypes = {
  anchorPoint: PropTypes.string,
  anchorName: PropTypes.string,
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  children: PropTypes.node,
};
Wrapper.defaultProps = {
  anchorPoint: null,
  anchorName: null,
  containerId: null,
  containerClass: null,
  children: null,
};
export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/wrapper/index.jsx